import { defineStore } from 'pinia'
import { useRouter } from 'vue-router'
import commonServices from '@/api/services/commonServices'
import { ref } from 'vue'

export const useCommonStore = defineStore('commonStore', () => {
  const router = useRouter()
  const countries = ref([])
  const enabledCountries = ref([])
  const languages = ref([
    {
      id: '51cae210-c456-46c5-a091-56de7082de36',
      title: 'English',
      code: 1,
      locale: 'en',
      enabled: true
    },
    {
      id: '6ebf4f11-e91f-48bf-994f-92090d0ca1e4',
      title: 'Deutsch',
      code: 1,
      locale: 'de',
      enabled: true
    }
  ])
  const dictionaries = ref(null)
  const steps = ref([
    {
      text: '1',
      isActive: true,
      isDisabled: false,
      routeName: 'StageOnboarding'
    },
    {
      text: '2',
      isActive: false,
      isDisabled: true,
      routeName: 'AccountOnboarding'
    }
  ])
  const activeStepRouteName = ref('StageOnboarding')

  const setActiveStep = (routeNameStep) => {
    const currentActiveStepIndex = steps.value.findIndex(
      (step) => step.isActive
    )
    const nextActiveStepIndex = steps.value.findIndex(
      (step) => step.routeName === routeNameStep
    )

    if (steps.value[nextActiveStepIndex]) {
      const nextActiveStep = steps.value[nextActiveStepIndex]
      steps.value[currentActiveStepIndex].isActive = false
      nextActiveStep.isActive = true
      nextActiveStep.isDisabled = false
      activeStepRouteName.value = nextActiveStep.routeName
      router.push({ name: activeStepRouteName.value })
    }
  }

  const setDisableStep = (routeNameStep) => {
    const stepToDisableIndex = steps.value.findIndex(
      (step) => step.routeName === routeNameStep
    )

    if (steps.value[stepToDisableIndex]) {
      steps.value[stepToDisableIndex].isActive = false
      steps.value[stepToDisableIndex].isDisabled = true
    }
  }

  const getCountries = async () => {
    const { data } = await commonServices.getAllCountries()
    countries.value = [...data['countries']]
  }

  const sendLeadForm = async (payload) => {
    await commonServices.sendLead(payload)
  }

  return {
    countries,
    enabledCountries,
    languages,
    dictionaries,
    steps,
    activeStepRouteName,
    setActiveStep,
    setDisableStep,
    getCountries,
    sendLeadForm
  }
})
